export default "__VITE_ASSET__8VuF5vCb__"